import { Link } from "react-router-dom";

export default function Logo({ className = "", showText = true }) {
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="logo-link">
      <svg width="30" height="30" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
        <path d="M22 24 H78 L56 52 V78 L44 84 V52 Z" stroke="hsl(var(--primary))" strokeWidth="7" strokeLinejoin="round" strokeLinecap="round" fill="none" />
      </svg>
      {showText && (
        <span className="leading-[0.85] font-extrabold tracking-tight text-foreground" style={{ fontFamily: "Manrope" }}>
          <span className="block text-[13px] uppercase tracking-[0.12em]">Fiction</span>
          <span className="block text-[13px] uppercase tracking-[0.12em]">&amp; Filters</span>
        </span>
      )}
    </Link>
  );
}
